<template>
  <div class="asc-page-coming-soon">
    <asc-header size="h2" :value="label"></asc-header>
  </div>
</template>

<script>
import AscHeader from '@/components/atoms/AscHeader'
export default {
  name: 'AscPageComingSoon',

  components: {
    AscHeader,
  },

  props: {
    label: {
      type: String,
      default: 'Page Coming Soon',
    },
  },
}
</script>

<style lang="scss">
.asc-page-coming-soon {
  display: flex;
  align-items: center;
  justify-content: center;
  height: calc(100vh - 120px);
  background-color: $primary-white;
}
</style>
